import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const Wrapper = styled.div`
  position: sticky;
  top: 60px;
  height: 48px;
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(1.75, 1, 1.75, 1)};
  background: ${({ theme }) => theme.colors.neutrals.white};
  z-index: 15;
  overflow-x: auto;
  box-shadow: 0 -1px 0 0 ${({ theme }) => theme.colors.neutrals.grey8} inset;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox, Safari 18.2+, Chromium 121+ */
  &::-webkit-scrollbar {
    display: none; /* Older Safari and Chromium */
  }
  > div:empty {
    display: none;
  }
  > div {
    display: flex;
    align-items: center;
    padding: ${({ theme }) => theme.spacing(0, 2)};
    position: relative;
  }
  > div:not(:first-of-type):before {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    height: 13px;
    background-color: ${({ theme }) => theme.colors.neutrals.grey7};
    width: 1px;
  }
`;

export const MenuItemWrapper = styled(SmallText)<{ isActive: boolean }>`
  color: ${({ theme, isActive }) => isActive ? theme.colors.brand.main : theme.colors.neutrals.grey1};
  cursor: pointer;
  white-space: nowrap;
  :empty {
    display: none;
  }
`;

